import { T_Product } from '../types';

export const normalizeQuerySkus = (products: T_Product[], tokens: string[]) => {
  const skuByToken = new Map<string, string>();

  for (const product of products) {
    skuByToken.set(product.sku, product.sku);
    // skuByToken.set(product.id.toString(), product.sku);
  }
  return Array.from(new Set(tokens.map(token => skuByToken.get(token.trim())).filter((sku): sku is string => !!sku)));
};
